import React from "react";

const Homewelcome = () => {
    return (
        <div className="bg-primary-300 my-4 md:my-5 mx-5 sm:mx-10 text-primary-50 shadow-md leading-[1.5] p-4 rounded-md">
            <h4 className="text-[12px]">Welcome back</h4>
            <h1 className="text-[24px]">Adam Chuks</h1>
            <p className="text-[12px]">
                Your students completed 74% of the tasks.
            </p>
        </div>
    );
};

export default Homewelcome;
